import '../public/styles.css';
// eslint-disable-next-line import/no-unresolved
import { GoogleTagManager } from '@next/third-parties/google';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';

import Noop from 'components/common/Noop';
import useMount from 'hooks/useMount';
import useProgressBar from 'hooks/useProgressBar';
import { wrapper } from 'redux/store';
import createEmotionCache from 'utility/createEmotionCache';
import { getGTMCode } from 'utility/googleTagManager';

const KeepaThemeProvider = dynamic(() => import('components/KeepaThemeProvider'), { suspense: true });

const clientSideEmotionCache = createEmotionCache();

function MyApp(props) {
	const { Component, emotionCache = clientSideEmotionCache, pageProps } = props;
	const Layout = Component.Layout ?? Noop;
	const mount = useMount();
	useProgressBar();

	const gtmCode = getGTMCode();

	return (
		<>
			<KeepaThemeProvider emotionCache={emotionCache}>
				{mount && (
					<>
						<Layout>
							<Component {...pageProps} />
						</Layout>
					</>
				)}
			</KeepaThemeProvider>
			{gtmCode && <GoogleTagManager gtmId={gtmCode} />}
		</>
	);
}

MyApp.propTypes = {
	Component: PropTypes.elementType.isRequired,
	emotionCache: PropTypes.object,
	pageProps: PropTypes.object.isRequired,
};

export default wrapper.withRedux(MyApp);
export function reportWebVitals() {
	// Time to First Byte (TTFB)
	// First Contentful Paint (FCP)
	// Largest Contentful Paint (LCP)
	// First Input Delay (FID)
	// Cumulative Layout Shift (CLS)
	// console.log(metric);
}
